import React from 'react';
import ErrorPage from './ErrorPage';

const ErrorPageWrapper = ({
  error = false,
  navTitle,
  userMenu,
  children,
  title,
  message,
  action,
  userType,
  inMaintenance,
}) => {
  return (
    <>
      {/* error */}
      {error && (
        <ErrorPage
          navTitle={navTitle}
          userMenu={userMenu}
          title={title}
          message={message}
          action={action}
          userType={userType}
          inMaintenance={inMaintenance}
        />
      )}

      {/* no error */}
      {!error && children}
    </>
  );
};
export default ErrorPageWrapper;
